/* eslint-disable no-undef */
import React, { useEffect, useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { getAllWallets } from '../../../reducks/resources/wallet/actions'
import WalletListItem from '../WalletListItem/WalletListItem'
import LoadingBounce from '../LoadingBounce/LoadingBounce'
import Flex from '../Flex/Flex'
import {
  setWalletItemSelected,
  removeWalletItemSelected,
  getWalletItemSelected
} from '../../../utils/common'

import styles from './walletList.module.scss'
import ButtonToTop from '../ButtonToTop/ButtonToTopContainer'

const WalletList = ({ wallets }) => {
  const dispatch = useDispatch()
  const loadMoreRef = useRef(null)
  const { fetching, pagination } = useSelector((store) => store.walletReducer)

  const canLoadMore = useMemo(
    () => !fetching && pagination.currentPage < pagination.lastPage,
    [fetching, pagination]
  )

  /**
   * Infinite Scroll
   */
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0
    }

    const observer = new IntersectionObserver((entities) => {
      const target = entities[0]

      if (target.isIntersecting) {
        const increment = true
        dispatch(getAllWallets(increment))
      }
    }, options)

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [dispatch])

  const handleSelectedItem = (id) => setWalletItemSelected(id)

  useEffect(() => {
    const itemSelected = getWalletItemSelected()

    if (itemSelected) {
      const item = document.getElementById(itemSelected)

      uss.scrollIntoView(item)

      setTimeout(() => {
        removeWalletItemSelected()
      }, 300)
    }
  }, [])

  return (
    <>
      {pagination.currentPage > 1 && <ButtonToTop />}
      <div className={styles.list}>
        {wallets.length > 0 &&
          wallets.map((wallet) => (
            <WalletListItem
              key={`${wallet.id}-${wallet.walletCode}`}
              {...{
                wallet,
                onClick: () => handleSelectedItem(item.walletCode)
              }}
            />
          ))}
      </div>

      <Flex
        alignItems="center"
        justifyContent="center"
        padding="20px 0px"
        style={{ display: canLoadMore ? 'flex' : 'none' }}
      >
        <LoadingBounce ref={loadMoreRef} />
      </Flex>
    </>
  )
}

WalletList.defaultProps = {
  wallets: []
}

WalletList.propTypes = {
  wallets: PropTypes.array
}

export default WalletList
